<template>
    <div class="input-wrapper">
        <label>
            <div class="d-flex align-items-start">
                <input
                    class="align-middle"
                    :type="inputHide ? 'hidden' : 'checkbox'"
                    :name="name"
                    v-model="value"
                    @change="handleChange(value)"
                    :checked="checked"
                    @click="handleElementClick(name, 'checkbox')"
                />
                <span
                    class="align-middle checkbox-label"
                    :class="{ 'checkbox-label-hidden': inputHide }"
                    v-html="displayName"
                ></span>
            </div>

            <div class="error" v-if="displayErrorMessage">{{ displayErrorMessage }}</div>
        </label>
    </div>
</template>

<script>
import { useField } from 'vee-validate'
import { useStore } from 'vuex'
import { titleCase } from '@js/utilities/language.js'

// lodash components
import _get from 'lodash/get'

export default {
    props: {
        errorMessage: String,
        customErrorMessage: String,
        label: String,
        name: String,
        validationRules: Object,
        vuexKey: String,
        checked: Boolean,
        inputHide: Boolean,
    },
    setup(props) {
        const store = useStore()
        const { errorMessage, handleChange, resetField } = useField(props.name, props.validationRules, {
            label: titleCase(props.name),
        })

        return {
            errorMessage,
            handleChange,
            resetField,
            store,
        }
    },
    mounted() {
        this.resetField({
            value: this.value,
        })
    },
    computed: {
        value: {
            get() {
                return this.store.getters.fieldValue(this.name, this.vuexKey || 'data', !!this.vuexKey, !!this.vuexKey)
            },
            set(value) {
                if (this.vuexKey) {
                    this.store.commit('setDataFieldValue', {
                        name: this.name,
                        value: value,
                        key: this.vuexKey,
                    })
                } else {
                    this.store.dispatch('setFieldValue', {
                        name: this.name,
                        value: value,
                    })
                }

                if (value) {
                    this.handleChange(value)
                }
            },
        },
        displayName() {
            return this.label || this.titleCase(this.name)
        },
        serverError() {
            return this.store.getters.fieldServerError(this.name)
        },
        displayErrorMessage() {
            return this.errorMessage ? this.customErrorMessage || this.errorMessage : this.serverError
        },
    },
    methods: {
        check(checkValue) {
            this.value = checkValue
            this.handleChange(this.value)
        },
        handleElementClick(elementName, elementType) {
            this.emitter.emit('elementClicked', { elementName, elementType })
        },
    },
}
</script>

<style lang="scss" scoped>
input {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 4px;
    border: solid 2px #b3b9c5;
    cursor: pointer;
    flex-basis: 18px;
    flex-grow: 0;
    flex-shrink: 0;
    height: 18px;
    margin-right: 10px;
    position: relative;
    user-select: none;
    width: 18px;

    &.no-border {
        border: none;
    }

    &:focus {
        outline: none;
        padding: 0;
    }

    &:checked {
        &:before {
            content: '';
            background-color: var(--secondary);
            border-radius: 2px;
            height: 12px;
            left: 1px;
            position: absolute;
            top: 1px;
            width: 12px;
        }
    }
}

.checkbox-label {
    color: var(--input-text-color);
}

.checkbox-label-hidden {
    margin-left: 27px;
}
</style>
